import type { HTMLProps, PropsWithChildren } from 'react';

import { TOOLTIP_ICON } from './components';

export enum TOOLTIP_CONST {
  TEST_ID = 'tooltip',
}

export type Action =
  | { type: TooltipAction.setPosition; payload: unknown }
  | { type: TooltipAction.toggleVisibility; payload?: boolean };

export type PositionX = 'left' | 'center' | 'right';

export type PositionY = 'up' | 'down';

type Tooltip = HTMLProps<HTMLDivElement> & {
  align?: PositionX;
  content: string;
  customIcon?: `${TOOLTIP_ICON}`;
  direction?: PositionY;
  withIcon?: boolean;
  onClick?: (string) => void;
  isPdp?: boolean;
  openInHover?: boolean;
};

export enum TooltipAction {
  setPosition = 'SET_POSITION',
  toggleVisibility = 'TOGGLE_VISIBILITY',
}

export type TooltipProps = PropsWithChildren<Tooltip>;

export type TooltipState = {
  isVisible: boolean;
  positionY: PositionY;
  positionX: PositionX;
};
